import styled from 'styled-components';

import { useAlert } from '../context/alertContext';
import Icon from './Icon';
import Button from './Button';

export const Alert = () => {
  const { alert } = useAlert();

  const colors = {
    success: {
      name: 'green',
      backgroundColor: '#42c67f',
    },
    question: {
      name: 'blue',
      backgroundColor: '#3a58de',
    },
    warning: {
      name: 'red',
      backgroundColor: '#f4736b',
    },
  };

  const AlertIcon = () => {
    switch (alert.type) {
      case 'question':
        return <Icon iconName='faQuestion' color='#fff' size='2x' />;
      case 'success':
        return <Icon iconName='faCheck' color='#fff' size='2x' />;
      case 'warning':
        return <Icon iconName='faExclamationTriangle' color='#fff' size='2x' />;
      default:
        return '';
    }
  };

  return (
    alert && (
      <AlertContainer>
        <AlertBox>
          <AlertBoxHeader color={colors[alert.type]} type={alert.type}>
            <AlertIcon />
          </AlertBoxHeader>
          <AlertBoxBody>
            <h2>{alert.body.header}</h2>
            <p>{alert.body.message}</p>
          </AlertBoxBody>
          <ButtonsWrapper>
            {Object.entries(alert.buttons).map(([key, value]) => (
              <Button
                key={key}
                variant={value.type}
                theme={colors[alert.type].name}
                onClick={value.action}
              >
                {value.text}
              </Button>
            ))}
          </ButtonsWrapper>
        </AlertBox>
      </AlertContainer>
    )
  );
};

export default Alert;

const AlertContainer = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.65);
  backdrop-filter: saturate(100%) blur(4px);
  z-index: 1000;
  transition: all 0.3s ease-in-out;
`;

const AlertBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 40rem;
  box-shadow: 0 0.125rem 0.62rem rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in-out;
  border-radius: 0.5rem;
`;

const AlertBoxHeader = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: bold;
  padding: 1.5rem;
  color: #fff;
  background-color: ${({ color }) => color.backgroundColor};
  align-items: center;
  transition: all 0.3s ease-in-out;
  border-radius: 0.5rem 0.5rem 0 0;
`;

const AlertBoxBody = styled.div`
  padding: 1.2rem;
  margin-bottom: 2.4rem;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.5rem;
`;
